import { render, staticRenderFns } from "./calendarResourceTaskView.vue?vue&type=template&id=247326fc&"
import script from "./calendarResourceTaskView.vue?vue&type=script&lang=js&"
export * from "./calendarResourceTaskView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports